import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Input, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, TouchableOpacity } from 'react-native';
import { useDispatch, useSelector} from 'react-redux';
import {counter, loginNextStep, sendCode, saveInfo} from '../../../store/actions/login'
import trackerApi from '../../api/tracker';
import { showMessage, hideMessage } from "react-native-flash-message";
import * as RootNavigation from '../../../root.navigation.js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as Device from 'expo-device';


const AgentIcon = (props) => (
  <Icon {...props} name='smartphone-outline'/>
);

const AlertIcon = (props) => (
  <Icon {...props} name='alert-triangle' style={{width:16, height:16, marginHorizontal: 10}} fill='#ffffff'/>
);
const SuccessIcon = (props) => (
  <Icon {...props} name='checkmark-circle-2' style={{width:16, height:16, marginHorizontal: 10}} fill='#ffffff'/>
);

export const ConfirmForm = ({ navigation }) => {
  const [resendDisable, setResendDisable] = useState(true)
  const phone = useSelector( state => state.login.phoneNumber);
  const [code, setCode] = useState('');
  const [timer, setTimer] = useState(59);
  const dispatch = useDispatch();

  if(timer>0){
    setTimeout(()=>{
      setTimer(timer-1)
    },1200)
  }

  const confirm = async()=>{
    // dispatch(sendCode(code))
    const device = {
      deviceBrand: Device.brand,
      deviceName: Device.deviceName,
      modelName: Device.modelName,
      osName: Device.osName,
      osVersion: Device.osVersion
    }
    const response = await trackerApi.post('/confirm', {phone, code, device});
    if(response.data.login){
        await AsyncStorage.setItem('userId', response.data.id)
        await dispatch(saveInfo(response.data.user))
        console.log(response.data.user);
        if(response.data.user.verified && response.data.user.enabled){
          showMessage({
            message: `${response.data.user.firstname} عزیز ${response.data.message}`,
            type: "success",
            icon: SuccessIcon
          });

          RootNavigation.navigate('Menu');
        }
        if (!response.data.user.verified){
          showMessage({
            message: `${response.data.user.firstname} عزیز حساب شما در حال بررسی و احراز هویت میباشد.`,
            type: "warning",
            icon: AlertIcon
          });
        }

        if (!response.data.user.enabled){
          showMessage({
            message: `${response.data.user.firstname} عزیز حساب شما غیرفعال شده است. لطفا با پشتیبانی تماس بگیرید.`,
            type: "warning",
            icon: AlertIcon
          });
        }
    }
    else{
      showMessage({
        message: response.data.error,
        type: "danger",
        icon: AlertIcon
      });
  }
}


  return (
      <Layout level='2' style={styles.container}>
      <Input
        style={{marginVertical:5, borderRadius:10, width: Dimensions.get('window').width-40}}
        textStyle={{letterSpacing:20, textAlign:'center'}}
        value={code}
        placeholder ='_____'
        accessoryLeft={AgentIcon}
        keyboardType = 'numeric'
        maxLength={5}
        onChangeText = {newValue =>{setCode(newValue)}}
        label={evaProps => <Text {...evaProps}>کدی که برای شما پیامک شده است را وارد نمایید</Text>}

        />
      <Layout level='2' style={{alignItems:'center', marginTop:10}}>
        <Layout level='2' style={{justifyContent:'space-between', flexDirection:'row', borderRadius:10, width: Dimensions.get('window').width-40}}>
        <Button style={{flex:2, marginHorizontal:5, borderRadius:10}} size='small' appearance='outline' onPress={()=>{setTimer(59)}} disabled={timer==0? false: true}>ارسال مجدد  00:{timer}</Button>
        <Button style={{flex:3, marginHorizontal:5, borderRadius:10}}
          size='small'
          onPress={confirm}
          >تایید</Button>
        </Layout>
          <TouchableOpacity onPress={()=>{dispatch(loginNextStep(false))}}>
          <Text category='c2' appearance='hint' style={{marginVertical:15}}>تغییر شماره همراه</Text>
          </TouchableOpacity>
        </Layout>
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    marginTop:25,
    justifyContent:'flex-start',
    alignItems:'flex-start'
  },
});
